import { EventHandler, Label, Progressbar } from "client/CommonComponents";
import close from "../../../../assets/images/Delete.svg"
import attachmentClose from "../../../../assets/images/Reject.svg"
import './ImportAsset.scss'

const ImportAsset = (props:any) => {
 
  const progressPercentage = '40';
  
    return(
        <div className="import-asset-block">
          <div className="upload-attachments">
            {/* drag and drop */}
            <div className="dragDrop">
              <div className="dropzone" onDrop={props?.handleDrop} onDragOver={props?.onDragOver}>
                <div className="draggable-container me-0">
                  <img src={attachmentClose} alt='upload' title='Drag and drop your file (or) Browse file'/>
                  <div className="sub-header">Drag and drop your file (or) Browse file</div>
                  <input
                    type="file"
                    className="file-browser-input"
                    name="file-browser-input"
                    multiple={true}
                    onChange={props?.onFileUpload}
                    disabled = {!props?.iAttachmentEditable}
                    accept={props?.accept}
                   data-attribute="ImportAsset_file_browser_input_Input" />
                </div>
              </div>
              {props?.error && <div className="upload-error-message">{props?.error}</div>}
              <div className="progress-bar mt-2">
                <div className="main-container">
                  <div className='upload-text pull-left'>
                    <p>Uploading</p>
                    <span>{progressPercentage}%- 10 Seconds remaining</span>
                  </div>
                  <div className="pull-right">
                    <img src={attachmentClose} alt='close' className='attachment-close' />
                  </div>
                </div>
                <Progressbar progress={progressPercentage}  data-attribute="ImportAsset_Default_Progressbar" />
              </div>
              {props?.list?.length ? (
                <div className="file-list">
                  {props?.list.map((file: any, index: any) => {
                    return (
                      <div className="file" key={index}>
                        <Label title={file.name || (file as any).fileName} data-attribute="ImportAsset_Default_Label">
                          {file.name || (file as any).fileName}
                        </Label>
                        {(file?.isFleet || file?.isFleet == undefined) && props?.iAttachmentEditable && !file?.isReceivedAssetImage ?                         
                            <EventHandler onEvent={() => props?.onRemoveExt(index)} data-attribute={`ImportAsset_${((file.name || (file as any).fileName || index)).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                              <img src={close} alt="close" />
                            </EventHandler>
                          : null}
                      </div>
                    )
                  })}
                </div>
              ) : (
                <div className="no-attachments">No Attachments are uploaded</div>
              )}
            </div>
            {/* drag and drop */}
          </div>       
        </div>
    )
}

export default ImportAsset;